import logo from 'assets/brands/netspark/logo.svg';
import sidebarLogo from 'assets/brands/netspark/sidebarLogo.svg';

export const NETSPARK_CONFIGS = {
  logo,
  sidebarLogo,
  title: 'Netspark',
};
